// extracted by mini-css-extract-plugin
module.exports = {"shortListIcon":"ShortListIcon_shortListIcon__2W6UG"};